/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_about_scoring_dq = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disqualification (DQ) logic — Drivers disqualified from race results are scored at their classified position but have qualifying points zeroed, matching the official F1 Fantasy game behavior.`)
};

const es_about_scoring_dq = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lógica de descalificación (DQ) — Los pilotos descalificados de resultados de carrera se puntuan en su posición clasificada pero sus puntos de clasificación se anulan, igualando el comportamiento del juego oficial F1 Fantasy.`)
};

const de_about_scoring_dq = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disqualifikations-Logik (DQ) — Disqualifizierte Fahrer werden an ihrer klassifizierten Position bewertet, aber die Qualifying-Punkte werden auf Null gesetzt, entsprechend dem offiziellen F1 Fantasy Spielverhalten.`)
};

const nl_about_scoring_dq = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diskwalificatie (DQ) logica — Coureurs die gediskwalificeerd worden, worden gescoord op hun geklasseerde positie maar krijgen hun kwalificatiepunten op nul gezet, overeenkomstig het officiële F1 Fantasy-spelgedrag.`)
};

const fr_about_scoring_dq = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logique de disqualification (DQ) — Les pilotes disqualifiés des résultats de course reçoivent les points de leur position classée mais voient leurs points de qualification annulés, conformément au comportement du jeu F1 Fantasy officiel.`)
};

const it_about_scoring_dq = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logica squalifica (DQ) — I piloti squalificati dai risultati gara vengono valutati in base alla posizione classificata ma i punti qualifica vengono azzerati, come nel gioco ufficiale F1 Fantasy.`)
};

const pt_br2_about_scoring_dq = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lógica de desclassificação (DQ) — Pilotos desclassificados dos resultados da corrida são pontuados na posição classificada, mas têm os pontos de classificatória zerados, seguindo o comportamento do jogo oficial F1 Fantasy.`)
};

const pt_about_scoring_dq = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lógica de desqualificação (DQ) — Pilotos desqualificados dos resultados da corrida são pontuados pela posição classificada, mas têm os pontos de qualificação anulados, seguindo o comportamento do jogo oficial F1 Fantasy.`)
};

const ja_about_scoring_dq = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`失格（DQ）ロジック — レース結果から失格されたドライバーは分類されたポジションでスコアリングされますが、予選ポイントはゼロになります。公式F1ファンタジーゲームの動作と一致。`)
};

const zh_about_scoring_dq = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取消资格（DQ）逻辑 — 被取消比赛资格的车手按其分类名次计分，但排位赛积分清零，与官方F1 Fantasy游戏行为一致。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const about_scoring_dq = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.about_scoring_dq(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("about_scoring_dq", locale)
	if (locale === "en") return en_about_scoring_dq(inputs)
	if (locale === "es") return es_about_scoring_dq(inputs)
	if (locale === "de") return de_about_scoring_dq(inputs)
	if (locale === "nl") return nl_about_scoring_dq(inputs)
	if (locale === "fr") return fr_about_scoring_dq(inputs)
	if (locale === "it") return it_about_scoring_dq(inputs)
	if (locale === "pt-BR") return pt_br2_about_scoring_dq(inputs)
	if (locale === "pt") return pt_about_scoring_dq(inputs)
	if (locale === "ja") return ja_about_scoring_dq(inputs)
	return zh_about_scoring_dq(inputs)
};